(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('linkActivityEditor', linkActivityEditor);

    function linkActivityEditor($timeout) {
        return {
            templateUrl: '/app/directives/activities/link-activity-editor.tpl.html',
            scope: {
                item: '=',
                placeholder: '@',
                editMode: '='
            },
            controller: LinkActivityEditorController,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, element, attr, ctrl, transclude) {
                if (ctrl.item && !ctrl.item.name) {
                    $timeout(function () {
                        element[0].querySelector('#itemName').focus();
                    });
                }
            }
        };
    }

    function LinkActivityEditorController($translate) {
        var vm = this;

        vm.protocol = 'https';
        vm.url = '';

        if (vm.item.link) {
            var split = vm.item.link.split('://');
            vm.protocol = split[0];
            vm.url = split[1];
        }
        
        vm.setProtocol = setProtocol;
        vm.updateLink = updateLink;
        
        function setProtocol(protocol) {
            vm.protocol = protocol;
            updateLink();
        }

        function updateLink() {
            if (!vm.url) {
                delete vm.item.link;
            } else {
                var split = vm.url.split('://');
                if (split.length > 1 && split[1].length > 0) {
                    switch (split[0].toLowerCase()) {
                        case 'http':
                            vm.protocol = 'http';
                            break;
                        case 'https':
                            vm.protocol = 'https';
                            break;
                        case 'ftp':
                            vm.protocol = 'ftp';
                            break;
                    }
                    vm.url = split[1];
                }

                vm.item.link = vm.protocol + '://' + vm.url;
            }
        }
    }

})();